import type { FC } from 'react'
import { twJoin } from 'tailwind-merge'

export const Footer: FC = () => (
  <footer
    className={twJoin(
      'w-full h-16',
      'flex flex-col items-center justify-center',
      'border-t border-stone-300 dark:border-stone-700',
    )}
  >
    <p className='text-sm'>&copy; 2026 Tomiki Aikido Spain</p>
    <p className='text-sm'>
      Made by{' '}
      <a
        href='https://carlos-aguilar.com'
        target='_blank'
        rel='noopener noreferrer'
      >
        Carlos Aguilar
      </a>
    </p>
  </footer>
)

export default Footer
